import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import Authorize from 'components/Providers/Authorize';
import PageWrapper from 'components/Shared/Page/Wrapper';
import PageTitle from 'components/Shared/Page/Title';
import withPusher from 'components/Providers/Pusher/withPusher';
import PageBanners from 'components/Layout/PageBanners';
import useTranslation from 'utils/hooks/useTranslation';
import useWalletPage from './useWalletPage';
import WalletEmptyState from './WalletEmptyState';
import WalletLoadError from './WalletLoadError';
import WalletDashboard from './Dashboard/index';

const Wallet = ({ history }) => {
  const { translateText } = useTranslation();
  const {
    isLoading,
    isHistoryFetching,
    isError,
    wallet,
    dashboard,
    pageNumber,
    transactionType,
    transactionStatus,
    orderBy,
    onPageChange,
    onPageSizeChange,
    onTransactionTypeChange,
    onTransactionStatusChange,
    onOrderByChange,
    onStatusChange,
    onRetry,
  } = useWalletPage();

  const renderWalletState = () => {
    if (isLoading) {
      return null;
    }
    if (isError && wallet === undefined) {
      return <WalletLoadError onRetry={onRetry} />;
    }
    if (wallet === null) {
      return <WalletEmptyState />;
    }
    if (dashboard) {
      return (
        <WalletDashboard
          dashboard={dashboard}
          isHistoryFetching={isHistoryFetching}
          pageNumber={pageNumber}
          transactionType={transactionType}
          transactionStatus={transactionStatus}
          orderBy={orderBy}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onTransactionTypeChange={onTransactionTypeChange}
          onTransactionStatusChange={onTransactionStatusChange}
          onOrderByChange={onOrderByChange}
          onStatusChange={onStatusChange}
        />
      );
    }
    return null;
  };

  return (
    <Authorize>
      <Helmet title="Wallet" />
      <PageBanners />
      <PageWrapper history={history} loading={isLoading}>
        <PageTitle
          title={translateText('corporateAccounts.menuLeft.wallet')}
          subtitle={dashboard?.walletName}
          description={translateText('corporateAccounts.wallet.description')}
        />
        <div className="card-body">{renderWalletState()}</div>
      </PageWrapper>
    </Authorize>
  );
};

export default withPusher(injectIntl(Wallet));
